module.exports = __webpack_public_path__ + "assets/router_white_24dp.svg";